/* Staffelblok (Multi-Solar). Hoort bij snippets/mts-pdp-staffel.liquid.
   Een tegel kiest de bijbehorende variant via Dawn's variantkiezer, zodat prijs, knop en URL meebewegen.
   De 2×/3×-pillen worden in de variantkiezer verborgen (de tegels nemen het over). Zet een bezoeker het
   aantal op 2 of 3 bij de losse variant, dan springt hij automatisch naar de staffelvariant. */
(function () {
  const blok = document.querySelector('[data-mts-staffel]');
  if (!blok) return;
  const tegels = [...blok.querySelectorAll('.mts-staffel__tegel')];
  const sectie = blok.closest('.shopify-section') || document;

  function radioVoor(optie) {
    return [...sectie.querySelectorAll('variant-selects input[type="radio"]')].find((i) => i.value === optie);
  }

  // 2×/3×-pillen uit de variantkiezer halen; de tegels tonen ze al. Via CSS, want Dawn rendert de
  // variantkiezer opnieuw bij elke variantwissel en zou classes op de inputs weer kwijtraken.
  const regels = tegels
    .filter((t) => Number(t.dataset.aantal) > 1)
    .map((t) => {
      const v = t.dataset.optie.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      return `variant-selects input[type="radio"][value="${v}"], variant-selects input[type="radio"][value="${v}"] + label { display: none !important; }`;
    });
  if (regels.length) {
    const style = document.createElement('style');
    style.textContent = regels.join('\n');
    document.head.appendChild(style);
  }

  function kies(tegel) {
    const r = radioVoor(tegel.dataset.optie);
    if (!r) return;
    const qty = sectie.querySelector('input[name="quantity"]');
    if (qty && Number(qty.value) !== 1) {
      qty.value = 1;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (!r.checked) {
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }
    markeer(Number(tegel.dataset.variant));
  }

  function markeer(variantId) {
    tegels.forEach((t) => {
      const actief = Number(t.dataset.variant) === variantId;
      t.classList.toggle('is-actief', actief);
      t.setAttribute('aria-pressed', actief ? 'true' : 'false');
    });
  }

  tegels.forEach((t) => t.addEventListener('click', () => kies(t)));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      const v = e && e.data && e.data.variant;
      if (v) markeer(Number(v.id));
    });
  }

  // Aantal 2 of 3 bij de losse variant → automatisch de staffelvariant.
  sectie.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches('input[name="quantity"]')) return;
    const basis = tegels.find((t) => Number(t.dataset.aantal) === 1);
    if (!basis || !basis.classList.contains('is-actief')) return;
    const doel = tegels.find((t) => Number(t.dataset.aantal) === Number(e.target.value) && !t.disabled);
    if (doel) kies(doel);
  });
})();
